import React from "react";
import { connect } from "react-redux";
import Spinner from 'react-bootstrap/Spinner';

import WhiteLabelForm from "./whiteLabelForm";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import { checkRageRightByProps } from "../utils/functions";
import { pageActions } from '../actions';

class WhiteLabel extends React.Component {
  componentDidMount() {
    this.props.dispatch(pageActions.setAdminPage());
  }

  renderForm() {
    const header = this.props.mandantStorage.header;
    const contactDetails = this.props.mandantStorage.contactDetails;
    const footer = this.props.mandantStorage.footer;
    const sonstigeEinstellungen = this.props.mandantStorage.sonstigeEinstellungen;
    const id = this.props.mandantStorage.id;
    const gpNummer = this.props.mandantStorage.gpNummer;
    const fileList = this.props.mandantStorage.fileList;
    const sonstigeSeitenverweise = this.props.mandantStorage.sonstigeLinks;
    const theme = this.props.mandantStorage.theme;
    const issuerUrl = this.props.mandantStorage.issuerUrl;
    const emKonditionenKz = this.props.mandantStorage.emKonditionenKz;
    const soKonditionenKz = this.props.mandantStorage.soKonditionenKz;
    const data = Object.assign(
      header,
      contactDetails,
      footer,
      sonstigeEinstellungen,
      fileList,
      { id, gpNummer, theme, issuerUrl, emKonditionenKz, soKonditionenKz },
      sonstigeSeitenverweise
    );
    if (data.headertitle === "" && data.theme === "") {
      return (
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      );
    } else {
      return (
        <WhiteLabelForm
          initialValues={data}
        />
      );
    }
  }

  render() {
    //console.info("isbladmin", this.props.configStorage.isBLBAdmin());
    //console.info("checkRageRightByProps", checkRageRightByProps(this.props));
    if (!checkRageRightByProps(this.props) && !this.props.configStorage.isBLBAdmin()) {
      return (
        <div>Sie haben nicht die benötigten Rechte.</div>
      );
    }
    return this.renderForm();
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage,
    rightStorage: store.rightStorage, // needed for checkRageRightByProps
    requiredRageRight: [RAGE_RIGHT.RAGE_ADMIN]
  };
})(WhiteLabel);
